export const toError = Promise.reject.bind(Promise);